module.exports = __webpack_public_path__ + "static/img/scorelist.c0c9e3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paper/scorelist.png
// module id = QYPc
// module chunks = 1